/** Campos dos cadastros configurados pelo administrador (obrigatório / opcional / oculto). */
import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export type FieldMode = "obrigatorio" | "opcional" | "oculto";
export interface FieldsResponse {
  forms: Array<{ key: string; label: string; fields: Array<{ key: string; label: string; default: FieldMode; locked?: string }> }>;
  config: Record<string, Record<string, FieldMode>>;
  lists: { instancias: string[]; sistemas: string[]; fases: string[]; situacoes: string[] };
}

export function useFieldsConfig() {
  return useQuery({ queryKey: ["config-campos"], queryFn: () => api.get<FieldsResponse>("/config/campos"), staleTime: 5 * 60_000 });
}

/** const F = useFields("processo"); F.req("instance"); F.show("officialLink") */
export function useFields(form: string) {
  const { data } = useFieldsConfig();
  const mode = (key: string): FieldMode => data?.config[form]?.[key] ?? "opcional";
  return {
    ready: !!data,
    mode,
    req: (key: string) => mode(key) === "obrigatorio",
    show: (key: string) => mode(key) !== "oculto",
    lists: { instancias: [], sistemas: [], fases: [], situacoes: [], ...(data?.lists ?? {}) },
    /** Obrigatórios vazios (para desabilitar o botão e avisar). */
    missing: (values: Record<string, unknown>) => Object.entries(values).filter(([k, v]) => mode(k) === "obrigatorio" && (v === null || v === undefined || v === "" || (Array.isArray(v) && !v.length))).map(([k]) => data?.forms.find((f) => f.key === form)?.fields.find((x) => x.key === k)?.label ?? k),
  };
}
